import { Box, Typography } from '@mui/material';

type Props = {
  description: string;
  value: string;
  testId: string;
};

export const LiveDataAlarmConditionRowItem = ({ description, value, testId }: Props) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      gap: '8px',
    }}
    data-sm={testId}
  >
    <Typography sx={{ fontSize: '14px' }}>{description}:</Typography>
    <Typography sx={{ fontSize: '14px', textAlign: 'right' }}>{value}</Typography>
  </Box>
);
